import Vue from 'vue';
import HeaderMenu from './components/HeaderMenu.vue'
import VideoPage from "./pages/Zhibo.vue"
import Hour24 from './components/Hour24.vue'


// 专题页面的小图标
import { Icon, Popup, ShareSheet, Image as VanImage, Dialog, Toast, Tag, Skeleton, CountDown  } from 'vant';
import { Timeline, TimelineItem, Card } from "element-ui";
Vue.use(Icon);
Vue.use(Popup);
Vue.use(ShareSheet);
Vue.use(VanImage);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Tag);
Vue.use(Skeleton);
Vue.use(CountDown);

Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Card);

Vue.config.productionTip = false

// 注入header导航
new Vue({
    render: h => h(HeaderMenu),
}).$mount('#header_menu')


// 注入video组件
new Vue({
    render: h => h(VideoPage),
}).$mount('#hnr_video_wrap')

new Vue({
    render: h => h(Hour24),
  }).$mount('#hour24')